module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department02-b6fa480c1834ada377982b30963c9033.jpg";